export default __webpack_public_path__ + "static/media/fauna-forums.41e9c070.png";